import React, { FC } from 'react';
import { ArrowRight } from 'lucide-react';

import {
  ModalHeader,
  ModalDescription,
  ModalFooter,
  ModalTitle
} from '@epoch-ui/components/Modal/modal';
import { Button } from '@epoch-ui/components/Button';
import { StepBar } from '@epoch-components/step-bar/StepBar';

import { usePlusOneRsvpControlModalContext } from '../plusOneRsvpControlContext';

export const ConfirmOwnerQuestionnaireContent: FC = () => {
  const {
    navigation,
    ownerGuest: { firstName }
  } = usePlusOneRsvpControlModalContext();

  return (
    <>
      <ModalHeader className="tw-m-0 tw-flex tw-flex-col tw-gap-1">
        <ModalTitle className="tw-m-0 tw-text-2xl tw-font-medium">
          Additional RSVP change
        </ModalTitle>
        <ModalDescription className="tw-m-0">
          {firstName} is also marked as incomplete. You&apos;ll need to complete {firstName}&apos;s
          questionnaire because this is their +1 guest.
        </ModalDescription>
      </ModalHeader>
      <ModalFooter className="tw-mt-0 tw-flex tw-flex-row tw-justify-end">
        <div className="tw-flex tw-flex-1 tw-items-center">
          <StepBar
            totalSteps={navigation.totalStepNumber}
            currentStep={navigation.currentStepNumber}
          />
        </div>
        <div className="tw-flex tw-flex-row tw-justify-center tw-gap-4">
          <Button
            size="sm"
            onClick={navigation.onClickBack}
            className="tw-rounded-xl"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            size="sm"
            className="tw-rounded-xl"
            variant="primary"
            onClick={navigation.onClickSubmit}
          >
            Continue
            <ArrowRight className="tw-ml-1 tw-h-4 tw-w-4" />
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};
